const apps = [
  {
    path: '',
    name: 'apps_list',
    showInMenu: true,
    components: {
      content: () => import('@/views/pages/apps/List.vue')
    },
    meta: {
      requiredRole: ['admin', 'middleAdmin'],
      moduleSlug: 'apps'
    }
  },
  {
    path: 'new',
    name: 'app_new',
    showInMenu: false,
    components: {
      content: () => import('@/views/pages/apps/New.vue')
    },
    meta: {
      requiredRole: ['admin', 'middleAdmin'],
    }
  },
  {
    path: ':id',
    name: 'app',
    components: {
      content: () => import('@/views/pages/apps/Edit.vue')
    },
    meta: {
      requiredRole: ['admin', 'middleAdmin'],
    }
  }
]

export default apps
